import React from "react";
import { FaFacebook, FaTwitter, FaInstagram } from "react-icons/fa";
import "./footer.css";

function Footer() {
  return (
    <div className="footer-main">
      <footer className="footer">
        <div className="footer-container">
          {/* Company Info */}
          <div className="footer-company">
            <img src="https://cdn.vectorstock.com/i/1000x1000/67/96/mvm-logo-letter-design-vector-41346796.webp" alt="Company Logo" className="footer-logo" />
            <p className="footer-text">Phone: +123 456 7890</p>
            <p className="footer-text">Email: contact@company.com</p>
          </div>

          {/* Quick Links */}
          <div className="footer-links">
            <h3>Quick Links</h3>
            <a href="/" className="footer-link">Home</a>
            <a href="/casestudy" className="footer-link">Case Study</a>
            <a href="/services" className="footer-link">Services</a>
            <a href="/contact" className="footer-link">Contact</a>
          </div>

          {/* Social Links */}
          <div className="footer-social">
            <h3>Follow Us</h3>
            <div className="social-icons">
              <a href="https://facebook.com" className="social-icon"><FaFacebook /></a>
              <a href="https://twitter.com" className="social-icon"><FaTwitter /></a>
              <a href="https://instagram.com" className="social-icon"><FaInstagram /></a>
            </div>
          </div>
        </div>
      </footer>

      {/* Copyright Section */}
      <div className="footer-copyright">
        <p>© 2015-2025 Company Name. All rights reserved.</p>
      </div>
    </div>
  );
}

export default Footer;
